import getDevSidebar from '../../customApp/sidebar';
const options = [
  ...getDevSidebar,
];
export default options;
